import React from 'react';
import { shallowEqual } from 'react-redux';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { InnerRender } from './InnerRender';
import { useResponsiveTable } from '../store';

const NoMemoResponsive = ({ tableName }: { tableName?: string }) => {
  const { name } = useResponsiveTableContext(tableName);

  const nonAdditionalFilters = useResponsiveTable((global) => {
    const state = global.responsiveTableSlice[name];
    return state?.filters.filter(
      (current) =>
        !current.isMeta &&
        state?.columns.find((search) => search.name === current.column),
    );
  }, shallowEqual);

  return (
    <InnerRender
      tableName={tableName}
      isResponsive
      filters={nonAdditionalFilters}
    />
  );
};

export const Responsive = React.memo(NoMemoResponsive);
